export const Bold = ({ children }) => (
  <div style={{ fontWeight: 'bold' }}>
    {children}
  </div>
);
